import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Customecommerceportfolio() {
  return (
    <section className="custom-ecommerce-portfolio p-100">
      <Container>
        <Swiper
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          // autoplay={false}
          pagination={{ clickable: true }}
          spaceBetween={10}
          modules={[Autoplay, Pagination]}
          breakpoints={{
            320: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
          }}
          className="portfolio-slider"
        >
          <SwiperSlide>
            <div className="ecomm-port-box">
              <h2 className="text-center mb-5">
                Web Portal Efficiency Success by TekRevol
              </h2>
              <Row>
                <Col
                  xs={12}
                  md={12}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="mb-4 mb-lg-0"
                >
                  <div className="icon">
                    <StaticImage
                      src="../../images/services-usa/web-portal/nde-offshore-logo.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={174}
                      height={50}
                    />
                  </div>
                  <div className="content">
                    <h3>NDE Offshore</h3>
                    <p>
                      NDE Offshore required a robust upgrade to their web
                      portals to support inspection, maintenance, and
                      construction services across multiple regions. TekRevol
                      enhanced their portals with improved backend stability and
                      flexibility, enabling smoother operations and better
                      service delivery.
                    </p>
                    <h5>The result</h5>
                    <ul>
                      <li>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#F47A1F"
                            d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                          ></path>
                          <path
                            fill="#F47A1F"
                            d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                          ></path>
                        </svg>
                        Improved portal uptime by 40%
                      </li>
                      <li>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#F47A1F"
                            d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                          ></path>
                          <path
                            fill="#F47A1F"
                            d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                          ></path>
                        </svg>
                        Streamlined maintenance scheduling by 30%
                      </li>
                      <li>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#F47A1F"
                            d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                          ></path>
                          <path
                            fill="#F47A1F"
                            d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                          ></path>
                        </svg>
                        Enhanced user access speed by 25%
                      </li>
                    </ul>
                    <Link
                      style={{ background: "#f47a14", color: "#fff" }}
                      to="/case-studies/nde"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                    >
                      View Case Study
                    </Link>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={12}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="text-center my-auto"
                >
                  <StaticImage
                    src="../../images/services-usa/web-portal/nde-offshore.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={482}
                    height={414}
                  />
                </Col>
              </Row>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="ecomm-port-box">
              <h2 className="text-center mb-5">
                Inventory Portal Success by TekRevol
              </h2>
              <Row>
                <Col
                  xs={12}
                  md={12}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="mb-4 mb-lg-0"
                >
                  <div className="icon">
                    <StaticImage
                      src="../../images/services-usa/web-portal/stock-ship-logo.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={132}
                      height={50}
                    />
                  </div>
                  <div className="content">
                    <h3>Stock n Ship</h3>
                    <p>
                      Stock n Ship needed an all-in-one platform to unify
                      inventory, order management, and product logistics for
                      stores and suppliers. TekRevol developed a comprehensive
                      web portal that delivers real-time insights into supply
                      chain processes, improving transparency and operational
                      efficiency.
                    </p>
                    <h5>The result</h5>
                    <ul>
                      <li>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#F47A1F"
                            d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                          ></path>
                          <path
                            fill="#F47A1F"
                            d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                          ></path>
                        </svg>
                        Increased inventory accuracy by 35%
                      </li>
                      <li>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#F47A1F"
                            d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                          ></path>
                          <path
                            fill="#F47A1F"
                            d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                          ></path>
                        </svg>
                        Reduced order processing time by 20%
                      </li>
                      <li>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill="#F47A1F"
                            d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                          ></path>
                          <path
                            fill="#F47A1F"
                            d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                          ></path>
                        </svg>
                        Improved supplier coordination by 30%
                      </li>
                    </ul>
                    <Link
                      style={{ background: "#f47a14", color: "#fff" }}
                      to="/case-studies/stock-ship"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                    >
                      View Case Study
                    </Link>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={12}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className="text-center my-auto"
                >
                  <StaticImage
                    src="../../images/services-usa/web-portal/stock-ship.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={728}
                    height={425}
                  />
                </Col>
              </Row>
            </div>
          </SwiperSlide>
        </Swiper>
      </Container>
    </section>
  );
}

export default Customecommerceportfolio;
